import React, { useState, useEffect } from "react";
import Axios from "./../../utils/api/axiosConf";
import { url } from '../../utils/api/api';
import { RedNotif, GreenNotif } from "../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../components/loading/loading";
import UPLOAD from "../../components/uoload/upload";
import { Col, Row } from "antd";
import { Uploder } from "../../utils/utils";
import BUTTON from "../../components/buttons/button";
import { color } from "../../utils/themes/color";
import { Navigate, useAsyncError, useNavigate } from "react-router-dom";
import recycleImg from "./../../assets/images/recycleBin.jpg";
import editImage from "./../../assets/images/edit.png";
import { Pagination } from 'antd';




export default function Edit() {

    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 });
    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [user, setUser] = useState([]);


    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}movements/search-movement-system?limit=5&pageNumber=${page.current}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {

                    setUser(response.data.docs);
                    setPage({
                        ...page,
                        current: response.data.page,
                        total: response.data.totalDocs

                    })
                    setLoading(false)
 

                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [page.current])



    const deleteMovement = (item) => {
        var t = [];

        user.filter(function (obj) {
            if (obj._id !== item._id) {
                t.push(obj)
            }
        });

        setUser(t)
        Axios.delete(`${url}movements/delete-movement/${item._id}`)
            .then(async (response) => {
                if (response.status === 200 || response.status === 201) {
                    GreenNotif(response.message);

                } else {
                    RedNotif(response.message);
                }
            })
            .catch((error) => {
                RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                console.log("error", error)
            });
    }


    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>

                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <BUTTON event={(e) => { navigate(`/movements`) }}

                            text="افزودن حرکت تمرینی جدید" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>


                <Row gutter={[8, 16]} style={{ marginTop: '64px' }} >
                    {
                        user.map((itm, idx) =>
                            <>

                                <Col offset={1} span={6} key={idx} xxl={6} xl={6} lg={6} md={6} sm={6} style={{ border: `1px solid ${color.primary}`, background: "white", height: "172px" }}>

                                    <Row style={{ marginTop: '18px'}}>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} >
                                           {
                                            itm.image != null ? 
                                             <img src={`${url}${itm.image.path}`} style={{  width: "100px", height: '100px'}} />
                                             : null
                                           }
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                                            <p style={{ color: color.primary, fontSize: "20px" }}>{itm.title}</p>
                                        </Col>
                                    </Row>
                                    <br></br>
                                    <Row style={{ marginRight: '24px' }}>
                                        <Col xxl={16} xl={16} lg={16} md={16} sm={16} >
                                            <p style={{ fontSize: "16px" }}>{itm.hardshipLevel}</p>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4}>
                                            <img src={editImage} style={{ width: "45%", cursor: "pointer" }} onClick={() => navigate(`/movements/editMovements?id=${itm._id}`)} />
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4}>
                                            <img src={recycleImg} style={{ width: "30%", cursor: "pointer" }} onClick={() => deleteMovement(itm)} />
                                        </Col>
                                    </Row>

                                </Col>
                            </>


                        )}
                </Row>
                
                <Row style={{ marginTop: '68px' }} gutter={20}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                    <Pagination defaultCurrent={page.current} total={page.total} />

                    </Col>
                </Row>


            </>
        )
    }


}

